import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { TransactionsHistory } from '../../components/main-screen';
import PageHeader from '../../modules/page-header';
import TokenBalance from '../../modules/token-balance';
import { BalanceInfo } from '../../services/api/dto/Balance';
import { RootState } from '../../types';
import currencyFormat from '../../utils/currencyFormat';
import './main.scss';

const Main: React.FC = () => {
  const { simpleTokenValue } = useSelector(
    (state: RootState) => get(state.balance.data, 'info', {}) as BalanceInfo
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[{ link: '', title: 'Главная' }]}
            isHideBalanceInformer
            iconType="main"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <div className="home">
            <div className="home__row">
              <div className="home__col-6">
                <TokenBalance
                  title="Денежные требования"
                  balance={currencyFormat(simpleTokenValue ?? 0, false)}
                  type="ruble"
                />
              </div>
            </div>
            <div className="home__row">
              <div className="home__col-12">
                <TransactionsHistory />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
